class SubscriptionSectionSwitcher {
    constructor() {
        this.subscriptionsData = null;
        this.selectors = {
            control: '[name="subscriptions-selector"]'
        };
        this.elements = {};
        this.checkoutUrl = '';
    }


    updateLinks(subscriptionId) {
        const subscriptionData = this.subscriptionsData.find(sub => sub.id === subscriptionId);
        if (!subscriptionData) {
            return;
        }

        const upgradeLinks = document.querySelectorAll('a[data-upgrade]');
        upgradeLinks.forEach(link => {
            link.setAttribute('data-upgrade-from', subscriptionData.sku);
            const upgradeLink = this.createUpgradeLink(
                subscriptionData.sku, 
                link.dataset.upgrade, 
                subscriptionId
            );
            this.handleActivationLimit(
                subscriptionData.activations, 
                parseInt( link.dataset.allowedactivations ), 
                link, 
                upgradeLink
            );
        });
    }

    handleActivationLimit(current, allowed, element, upgradeLink) {
        if (current > allowed) {
            if (!element.nextElementSibling?.classList.contains('activations_exceeded')) {
                const template = document.getElementById('activations_exceeded_template');
                element.insertAdjacentHTML('afterend', template.innerHTML);
            }
            element.style.display = 'none';
        } else {
            const sibling = element.nextElementSibling;
            if (sibling?.classList.contains('activations_exceeded')) {
                sibling.remove();
            }
            element.href = upgradeLink;
            element.style.display = 'block';
        }
    }

    createUpgradeLink(from, to, subId) {
        const decodePlan = encodeURIComponent(btoa(JSON.stringify([{ from, to }])));
        return `${this.checkoutUrl}?upgrade-plans=${decodePlan}&subscription=${subId}`;
    }

    initElements() {
        Object.entries(this.selectors).forEach(([element, selector]) => {
            this.elements[`$${element}`] = document.querySelector(selector);
        });
    }

    initSelected() {
        const queryParams = new URLSearchParams(window.location.search);
        const selected = queryParams.get('subscription_id');
        if ( selected && this.elements['$control']?.tagName === 'SELECT' ) {
            this.elements['$control'].value = selected;
        }
    }

    hideAllSections() {
        document.querySelectorAll('[class*="e-switch-"]').forEach(el => el.style.display = 'none');
    }

    init() {
        this.initElements();
        this.initSelected();
        this.hideAllSections();
        
        const control = this.elements['$control'];
        if (!control) {
            return;
        }

        const hideClass = control?.dataset?.hideClass;
        
        if (hideClass) {
            document.querySelectorAll('.' + hideClass).forEach(el => el.style.display = 'none');
        }
        
        this.subscriptionsData = window.subscriptionsData?.subscriptions || [];
        if( window.subscriptionsData?.checkoutUrl ) {
            this.checkoutUrl = window.subscriptionsData.checkoutUrl;
        }
        
        control.addEventListener('change', (event) => {
            const element = event.currentTarget;
            const value = element.value;
            const deviceMode = document.body.dataset.elementorDeviceMode;
            const identifier = element.tagName === 'INPUT' ? 
                element.dataset.sku : 
                element.querySelector('option:checked').dataset.sku;

            this.hideAllSections();
            document.querySelectorAll('.e-switch-' + identifier).forEach(el => {
                if (!el.classList.contains('elementor-hidden-' + deviceMode)) {
                    el.style.display = '';
                }
            });
            this.updateLinks(value);
        });
        
        const changeEvent = new Event('change');
        control.dispatchEvent(changeEvent);
    }
}

document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => new SubscriptionSectionSwitcher().init(), 500);
});
